// @flow

export const modeTypes = {
	default: 'default',
	claims: 'claims',
	osago: 'osago',
	kasko: 'kasko',
	dms: 'dms',
};

export const apiStatuses = {
	success: 'Success',
	fail: 'Fail',
};

export const workflowStatuses = {
	/** 
	 * Статус успешной проверки телефона
	*/
	passed: 'passed',
	/** 
	 * Статус закрытия модального окна
	*/
	dismissed: 'dismissed',
	/** 
	 * Статус ошибки при общении с сбл(не по вине пользователя)
	*/
	failed: 'failed',
};

export const actions = {
	check: 'check',
	verify: 'verify',
};

export const events = {
	modalClosed: 'hidden',
	confirmationPassed: '_passed',
	checkRequest: 'checkRequest',
	verifyRequest: 'verifyRequest',
};
